"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = exports.NotificationServiceImpl = exports.NotificationToastLevel = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var theme_1 = require("../theme");
var CSS = {
    container: 'c-Notification-Toast',
    text: 'mdl-snackbar__text',
    button: 'mdl-snackbar__action',
    message: 'dgn-notification__message',
    isActive: 'mdl-snackbar--active',
    MDL: {
        container: 'dgn-notification mdl-snackbar'
    }
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        'z-index': 999
    },
    _a));
var NotificationToastLevel;
(function (NotificationToastLevel) {
    NotificationToastLevel[NotificationToastLevel["SUCCESS"] = 0] = "SUCCESS";
    NotificationToastLevel[NotificationToastLevel["INFO"] = 1] = "INFO";
    NotificationToastLevel[NotificationToastLevel["WARN"] = 2] = "WARN";
    NotificationToastLevel[NotificationToastLevel["ERROR"] = 3] = "ERROR";
})(NotificationToastLevel || (exports.NotificationToastLevel = NotificationToastLevel = {}));
var TOAST_TIMEOUT_MS = 3500;
var NotificationServiceImpl = /** @class */ (function () {
    function NotificationServiceImpl() {
        this.isOpen = false;
        this.level = NotificationToastLevel.INFO;
        this.timeout = null;
    }
    NotificationServiceImpl.prototype.success = function (message) {
        this.message = message;
        this.level = NotificationToastLevel.SUCCESS;
        this.show();
    };
    NotificationServiceImpl.prototype.info = function (message) {
        this.message = message;
        this.level = NotificationToastLevel.INFO;
        this.show();
    };
    NotificationServiceImpl.prototype.warn = function (message) {
        this.message = message;
        this.level = NotificationToastLevel.WARN;
        this.show();
    };
    NotificationServiceImpl.prototype.error = function (message) {
        this.message = message;
        this.level = NotificationToastLevel.ERROR;
        this.show();
    };
    NotificationServiceImpl.prototype.errorAsString = function (message) {
        this.messageString = message;
        this.level = NotificationToastLevel.ERROR;
        this.show();
    };
    NotificationServiceImpl.prototype.view = function () {
        var className = [
            CSS.container,
            CSS.MDL.container,
            this.isOpen ? CSS.isActive : null
        ].join(' ');
        var messageText = '';
        if (this.messageString) {
            messageText = this.messageString;
        }
        else if (this.message) {
            messageText = (0, i18n_1.Translate)(this.message.key, this.message.attrs);
        }
        return (0, mithril_1.m)('div', { className: className }, [
            (0, mithril_1.m)('div', { className: CSS.text }, messageText)
        ]);
    };
    NotificationServiceImpl.prototype.show = function () {
        var _this = this;
        if (this.timeout != null) {
            services_1.Services.Window.window.clearTimeout(this.timeout);
        }
        this.timeout = services_1.Services.Window.window.setTimeout(function (_) { return _this.hide(); }, TOAST_TIMEOUT_MS);
        this.isOpen = true;
    };
    NotificationServiceImpl.prototype.hide = function () {
        if (this.timeout != null) {
            services_1.Services.Window.window.clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.isOpen = false;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], NotificationServiceImpl.prototype, "message", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], NotificationServiceImpl.prototype, "messageString", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], NotificationServiceImpl.prototype, "isOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], NotificationServiceImpl.prototype, "level", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], NotificationServiceImpl.prototype, "show", null);
    tslib_1.__decorate([
        mobx_1.action
    ], NotificationServiceImpl.prototype, "hide", null);
    return NotificationServiceImpl;
}());
exports.NotificationServiceImpl = NotificationServiceImpl;
exports.NotificationService = new NotificationServiceImpl();
//# sourceMappingURL=notification.service.js.map